<ng-template #windowTitleBar let-win>
  <span class="k-window-title"><span class="k-icon k-font-icon k-icon-xl k-i-form-element">
    </span> {{showTitle}}</span>
  <button kendoWindowCloseAction [window]="win"></button>
</ng-template>
<div class="k-overlay" *ngIf="editWinOpen"></div>

<kendo-grid [kendoGridBinding]="gridData" [sort]="sort" [sortable]="true" [groupable]="true" [resizable]="true"
  [filter]="filter" filterable="menu" (filterChange)="filterChange($event)" (sortChange)="sortChange($event)"
  style="height: calc(100vh - 200px); min-height: 400px;" [pageSize]="pageSize" [pageable]="true">

  <ng-template kendoGridToolbarTemplate position="top">
    <button (click)="onAddClick(windowTitleBar)" kendoButton class="btn btn-primary">
      <fa-icon icon="circle-plus"></fa-icon> Add Evaluation Question </button>
  </ng-template>

  <kendo-grid-column title="Edit" [width]="60">
    <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
      <button (click)="onEditClick(dataItem, windowTitleBar)" kendoButton class="btn btn-stn-grid">
        <fa-icon icon="edit"></fa-icon>
      </button>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column title="Sort Order" [width]="90">
    <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
      <button (click)="onUpClick(dataItem)" kendoButton class="btn btn-stn-grid" *ngIf="rowIndex != 0"
        style="margin-right: 4px">
        <fa-icon icon="arrow-up"></fa-icon>
      </button>
      <button (click)="onDownClick(dataItem)" kendoButton class="btn btn-stn-grid"
        *ngIf="rowIndex != gridData.length - 1 ">
        <fa-icon icon="arrow-down"></fa-icon>
      </button>

    </ng-template>
  </kendo-grid-column>


  <kendo-grid-column field="question" title="Question" [width]="250" [sortable]="false">
    <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter" let-filterService="filterService">
      <multicheck-filter [isPrimitive]="true" [field]="column.field" [filterService]="filterService"
        [currentFilter]="filter" [data]="distinctPrimitive(column.field)"></multicheck-filter>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column field="response_type" title="Response Type" [width]="100" [sortable]="false">
    <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter" let-filterService="filterService">
      <multicheck-filter [isPrimitive]="true" [field]="column.field" [filterService]="filterService"
        [currentFilter]="filter" [data]="distinctPrimitive(column.field)"></multicheck-filter>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column field="isCompulsory" title="Compulsory" [width]="90" [sortable]="false">
    <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter" let-filterService="filterService">
      <multicheck-filter [isPrimitive]="true" [field]="column.field" [filterService]="filterService"
        [currentFilter]="filter" [data]="distinctPrimitive(column.field)"></multicheck-filter>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column field="isSupervisor" title="Supervisor Applicable" [width]="90" [sortable]="false">
    <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter" let-filterService="filterService">
      <multicheck-filter [isPrimitive]="true" [field]="column.field" [filterService]="filterService"
        [currentFilter]="filter" [data]="distinctPrimitive(column.field)"></multicheck-filter>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column field="isSupervisee" title="Supervisee Applicable" [width]="90" [sortable]="false">
    <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter" let-filterService="filterService">
      <multicheck-filter [isPrimitive]="true" [field]="column.field" [filterService]="filterService"
        [currentFilter]="filter" [data]="distinctPrimitive(column.field)"></multicheck-filter>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column field="isProfessional" title="Professional Applicable" [width]="90" [sortable]="false">
    <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter" let-filterService="filterService">
      <multicheck-filter [isPrimitive]="true" [field]="column.field" [filterService]="filterService"
        [currentFilter]="filter" [data]="distinctPrimitive(column.field)"></multicheck-filter>
    </ng-template>
  </kendo-grid-column>


  <kendo-grid-column title="Activate / Deactivate" field="active" [width]="90" [sortable]="false">
    <ng-template kendoGridCellTemplate let-dataItem>
      <input type="checkbox" kendoCheckBox size="large" [checked]="dataItem.active" (click)="setActive(dataItem)" />
    </ng-template>
    <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter" let-filterService="filterService">
      <multicheck-filter [isPrimitive]="true" [field]="column.field" [filterService]="filterService"
        [currentFilter]="filter" [data]="distinctPrimitive(column.field)"></multicheck-filter>
    </ng-template>
  </kendo-grid-column>

  <ng-template kendoPagerTemplate>
    <kendo-pager-info *ngIf="pageSize > 0"></kendo-pager-info>
  </ng-template>

</kendo-grid>

<kendo-dialog-actions>
  <button kendoButton (click)="onCancelAction()" class="btn btn-primary">Close</button>
</kendo-dialog-actions>
